<template>
  <div>
    <b-alert show variant="info">
      <i class="fas fa-info-circle fa-lg mr-1" />
      <b v-html="termStateAlert" />
    </b-alert>
    <Search
      :title="$lang.profileLang.term_state_list"
      :allowFields="$lang.profileLang.term_state_fields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      routeName="survey_group_edit"
      removeModalSize="lg"
      :defaultViewCount="10"
      :dynamicButtons="dynamicButtons"
      primaryKey="code"
      ref="termState"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddTermState :code="code" @close="search.close" @getData="getData" />
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddTermState from "../addTermState.vue";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  components: {
    Search,
    AddTermState,
  },
  data() {
    return {
      code: this.$route.params.code,
      dynamicButtons: [
        {
          id: "45",
          name: "termRegisterCode",
          text: this.$lang.add_code,
          iconFont: "fas fa-qrcode fa-lg text-primary ",
          AllowPermissions: ["admin"],
          click: this.goToCodePage,
        },
        {
          id: "0",
          name: "edit",
          click: this.goToEditTermState,
        },
        {
          id: "1",
          name: "delete",
        },
      ],
      permissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["profile", "term_state"], [this.code]);
    },
    termStateAlert() {
      return `برای هر دوره حتما بایستی مراحل <b class="text-primary">پیش ثبت نام</b> و <b class="text-primary">تکمیل نمایه فردی</b> را ایجاد نمایید.`;
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    getData() {
      this.$refs.termState.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    goToEditTermState(item) {
      this.$router.push({
        name: "edit_term_state",
        params: {
          term_code: this.code,
          term_state_code: pathOr(null, ["code"], item),
        },
      });
    },
    goToCodePage(item) {
      this.$router.push({
        name: "term_register_code_manager",
        params: {
          code: this.code,
        },
      });
    },
  },
};
</script>